import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import PoweredBy from '~/assets/PoweredBy';
import { useBrandContext } from '~/brands/BrandContext';
import { Link } from '~/components';

import {
  Body,
  FooterContainer,
  FooterLabel,
  FooterLabelMobile,
  GoBackChevron,
  GoBackContainer,
  HeaderContainer,
  Infographic,
  Logo,
  PageContainer,
  PrivacyPolicyLink,
  RightFooterContainer,
  RightScreen,
  SideBanner,
  Title,
} from './UnauthenticatedLayout.styles';
const WelcomeAnimation = React.lazy(() => import('./components/WelcomeAnimation'));

interface UnauthenticatedLayoutProps {
  title: string;
  children: ReactNode;
  header?: ReactNode;
  onGoBack?: () => void;
  pageContainerMaxWidth?: string;
  showBack?: boolean;
  styleTitle?: any;
}

const UnauthenticatedLayout = ({
  title,
  children,
  header,
  pageContainerMaxWidth,
  onGoBack,
  showBack,
  styleTitle,
}: UnauthenticatedLayoutProps): any => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { brand, poweredByVisible } = useBrandContext();
  const copyright = ` © Copyright ${new Date().getFullYear()} ${brand?.appName || 'VisitIQ'}`;
  const onBack = () => (onGoBack ? onGoBack() : navigate(-1));

  return (
    <Body>
      <SideBanner>
        <WelcomeAnimation />
        <Infographic />
        <FooterContainer>
          <FooterLabel $isCobrand={!!brand}>{copyright}</FooterLabel>
        </FooterContainer>
      </SideBanner>
      <RightScreen>
        <HeaderContainer>
          <Logo />
          {!!header && header}
        </HeaderContainer>
        <PageContainer maxWidth={pageContainerMaxWidth}>
          {!!showBack && (
            <GoBackContainer onClick={onBack}>
              <GoBackChevron />
              <Link onClick={onBack}>{t('auth.common.goBack')}</Link>
            </GoBackContainer>
          )}
          <Title style={styleTitle}>{title}</Title>
          {children}
        </PageContainer>
        <RightFooterContainer>
          <FooterLabelMobile>{copyright}</FooterLabelMobile>
          <PrivacyPolicyLink href={'/privacy-policy.html'}>{t('auth.common.privacyPolicy')}</PrivacyPolicyLink>
          {!!brand && poweredByVisible && <PoweredBy />}
        </RightFooterContainer>
      </RightScreen>
    </Body>
  );
};

export default UnauthenticatedLayout;
